export default __webpack_public_path__ + "static/media/help16.a662f373.png";